import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import UnauthorizedPage from "../../UnauthorizedPage";
import OemEpNoTable from "./ManageEpNoAccountsForm";
import ManageBudgetForm from "./ManageBudgetForm";
import ManageAccountBudgetTable from "./ManageAccountBudgetTable"; // Import the new component
import Toast from "./Toast";
import { set } from "react-hook-form";

const apiUrl = process.env.REACT_APP_API_URL;

export default function CostConfig() {
  const [error, setError] = useState(null);
  const [epNoData, setEpNoData] = useState([]);
  const [budgetData, setBudgetData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEpNo, setSelectedEpNo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [oem, setOem] = useState("");
  const [epNo, setEpNo] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [refreshYearBudget, setRefreshYearBudget] = useState(false);
  const [refreshAccountBudget, setRefreshAccountBudget] = useState(false);
  const [toast, setToast] = useState(null);

  const accessToken = useSelector((state) => state.accessToken.value);

  useEffect(() => {
    fetchEpNoData();
  }, [accessToken, refresh]);


  useEffect(() => {
    fetchBudgetData();
  }, [accessToken, refreshYearBudget]);

  const fetchEpNoData = async () => {
    setLoading(true);
    try {
      const query = `
        query MyQuery {
          getEpNoandOem {
            id
            EpNo
            Oem
            Users
          }
        }
      `;

      const response = await axios.post(
        apiUrl,
        { query },
        {
          headers: {
            Authorization: accessToken,
          },
        }
      );

      if (response.data.errors && response.data.errors[0].errorType === "Unauthorized") {
        setError("Unauthorized");
      } else if (response.data.data && response.data.data.getEpNoandOem) {
        setEpNoData(response.data.data.getEpNoandOem);
      }
    } catch (error) {
      console.error("Error fetching EP No data:", error);
      setToast({
        type: 'error',
        message: 'Failed to fetch EP No data'
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchBudgetData = async () => {
    try {
      const query = `
        query MyQuery {
          getYearBudget {
            id
            Year
            Budget
          }
        }
      `;

      const response = await axios.post(
        apiUrl,
        { query },
        {
          headers: {
            Authorization: accessToken,
          },
        }
      );

      if (response.data.errors && response.data.errors[0].errorType === "Unauthorized") {
        setError("Unauthorized");
      } else if (response.data.data && response.data.data.getYearBudget) {
        setBudgetData(response.data.data.getYearBudget);
      }
    } catch (error) {
      console.error("Error fetching Budget data:", error);
      setToast({
        type: 'error',
        message: 'Failed to fetch Budget data'
      });
    }
  };


  const clearToast = () => setToast(null);

  if (error === "Unauthorized") {
    return <UnauthorizedPage />;
  }

  return (
    <div className="p-4 bg-gradient-to-b from-[#003366]/5 to-white">

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <CircularProgress />
        </div>
      ) : (
        <div className="flex flex-col gap-6">
          {/* First row with two columns */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* EP No/OEM Table */}
            <div>
              <OemEpNoTable
                epNoData={epNoData}
                accessToken={accessToken}
                setError={setError}
                setRefresh={setRefresh}
                refresh={refresh}
                setToast={setToast}
              />
            </div>

            {/* Budget Table */}
            <div>
              <ManageBudgetForm
                budgetData={budgetData}
                accessToken={accessToken}
                setError={setError}
                setRefresh={setRefreshYearBudget}
                refresh={refreshYearBudget}
                setToast={setToast}
                name="Year Budget"
              />
            </div>
          </div>

          {/* Second row with full-width Account Budget table */}
          <div className="col-span-full">
            <ManageAccountBudgetTable
              accessToken={accessToken}
              setError={setError}
              setRefresh={setRefreshAccountBudget}
              refresh={refreshAccountBudget}
              setToast={setToast}
            />
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={clearToast}
        />
      )}
    </div>
  );
}